import React, { Component, PropTypes } from 'react';
import cx from 'classnames';

const DEFAULT_CLASSES = cx(
  'text-center pd-sm border-bottom-color-light-gray',
  'bg-color-lightest-gray border-bottom-width-1px border-bottom-style-solid',
);

export default class PopoverTitle extends Component {
  static propTypes = {};

  static defaultProps = {};

  render() {
    const { children, className } = this.props;

    return (
      <div className={cx(DEFAULT_CLASSES, className)}>
        {children}
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/js/components/layout/PopoverTitle.jsx